import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const ChangePasswordScreen = () => {
  const { user, setUser, logout } = useAuth();
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const error = f.next && f.next.length < 10 ? "Mínimo 10 caracteres" : f.next && f.next === f.current ? "Debe ser distinta a la temporal"
    : f.confirm && f.confirm !== f.next ? "No coincide" : null;
  const save = async () => {
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      const { data } = await api.get("/auth/me");
      setUser(data);
      toast.success("Contraseña actualizada. Cerramos tus otras sesiones.");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="change-password-screen" className="min-h-screen flex items-center justify-center px-5 bg-[var(--c-bg)]">
      <div className="w-full max-w-sm c-card p-6 space-y-4">
        <KeyRound className="w-9 h-9 c-accent" />
        <div className="space-y-1">
          <h1 className="font-heading text-2xl font-extrabold tracking-tight">Cambia tu contraseña</h1>
          <p className="text-sm c-text-2">Hola {user?.name?.split(" ")[0]}. Entraste con una contraseña temporal; crea una nueva para continuar.</p>
        </div>
        <input data-testid="change-password-current" type="password" autoComplete="current-password" className="c-input" placeholder="Contraseña temporal" value={f.current} onChange={set("current")} />
        <input data-testid="change-password-new" type="password" autoComplete="new-password" className="c-input" placeholder="Nueva contraseña (mínimo 10)" value={f.next} onChange={set("next")} />
        <input data-testid="change-password-confirm" type="password" autoComplete="new-password" className="c-input" placeholder="Confirma la nueva" value={f.confirm} onChange={set("confirm")} />
        {error && <p data-testid="change-password-error" className="text-xs text-red-600">{error}</p>}
        <button data-testid="change-password-submit" disabled={busy || !!error || !f.current || !f.next || f.confirm !== f.next} onClick={save} className="c-btn-primary w-full py-3 flex items-center justify-center gap-2">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Guardar contraseña
        </button>
        <button data-testid="change-password-logout" onClick={logout} className="w-full text-sm c-muted">Salir</button>
        <p className="text-center text-[10px] c-muted">Powered by NAMTECH</p>
      </div>
    </div>
  );
};
